import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n/index'
import './assets/style/index.less'
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole();
// Vue.use(vConsole)

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    device() {
      return document.documentElement.clientWidth >= 767 ? 'pc' : 'mobile'
    },
    isTP() {
      return navigator.userAgent.indexOf('TokenPocket') > -1
    }
  }
})

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
